<div [ngStyle]="{ 'margin-top': addTopMargin ? '8px' : '0' }">
  <div class="navigation-item menu-item" (click)="goToPage('/shop')">
    <mat-icon svgIcon="shop-icon" class="navigation-icon shop"></mat-icon>
    <span class="navigation-text text-trim">Shop</span>
  </div>
  <div class="navigation-item menu-item" (click)="goToPage('/departments')">
    <mat-icon
      svgIcon="departments-menu-icon"
      class="navigation-icon department"></mat-icon>
    <span
      class="navigation-text text-trim"
      [class.active-page]="activePage === 'DEPARTMENTS'">
      Wohnbereichs-Verwaltung
    </span>
  </div>
  <div class="navigation-item menu-item" (click)="goToPage('/order-history')">
    <mat-icon svgIcon="recent-icon" class="navigation-icon"></mat-icon>
    <span
      class="navigation-text text-trim"
      [class.active-page]="activePage === 'ORDER_HISTORY'">
      Bestellhistorie
    </span>
  </div>
  <div class="navigation-item menu-item" (click)="goToPage('downloads')">
    <mat-icon svgIcon="download-icon" class="navigation-icon"></mat-icon>
    <span
      class="navigation-text text-trim"
      [class.active-page]="activePage === 'DOWNLOADS'">
      Downloads
    </span>
  </div>
  <div
    class="navigation-item menu-item"
    (click)="goToPage('/customer-profile')">
    <mat-icon svgIcon="settings-icon" class="navigation-icon"></mat-icon>
    <span
      class="navigation-text text-trim"
      [class.active-page]="activePage === 'PROFILE'">
      Einrichtungs-Profil
    </span>
  </div>
  <div class="navigation-item menu-item" (click)="redirectToHelpPage()">
    <mat-icon svgIcon="help-icon" class="help-icon"></mat-icon>
    <span
      class="navigation-text text-trim"
      [class.active-page]="activePage === 'HELP'">
      Hilfe & Tipps
    </span>
  </div>
  <mat-divider
    class="menu-item divider"
    style="background-color: black"></mat-divider>
  <div class="additional-part">
    <div class="container menu-item">
      <app-profile-avatar
        (click)="goToPage('/customer-profile')"
        [image]="customer?.image"
        [defaultIcon]="'customer-icon'"
        [color]="'#CCCCCC'"
        [size]="40"
        class="customer-img"></app-profile-avatar>
      <div class="info">
        <p class="name">
          {{ customer.name }}
        </p>
        <p class="sub-text text-trim">Kundennnummer: {{ customer.id }}</p>
      </div>
    </div>
  </div>
  <div style="display: flex; flex-direction: column; gap: 12px">
    <button
      *ngIf="loggedUser.customerIds.length > 1"
      class="menu-item menu-button customer-change"
      style="justify-content: space-between"
      (click)="redirectToCustomerSelection()">
      <mat-icon
        svgIcon="customer-change-icon"
        class="customer-change-icon"></mat-icon>
      <span class="text-trim">Einrichtung wechseln</span>
      <div style="width: 15px"></div>
    </button>
  </div>
  <mat-divider
    class="menu-item divider"
    style="background-color: black"
    [ngClass]="{
      'less-space': loggedUser.customerIds.length < 2
    }"></mat-divider>
  <div class="additional-part">
    <div class="container menu-item">
      <app-profile-avatar
        [image]="loggedUser.image"
        [name]="loggedUser.getName()"
        [color]="loggedUser.color"
        [size]="40"></app-profile-avatar>
      <div class="info">
        <p class="name">{{ loggedUser?.name }} {{ loggedUser?.surname }}</p>
        <p class="sub-text text-trim">{{ loggedUser?.email }}</p>
      </div>
    </div>
    <mat-icon
      svgIcon="settings-icon"
      class="navigation-icon settings-icon"
      (click)="goToProfilePage()"></mat-icon>
  </div>
  <div style="display: flex; flex-direction: column; gap: 12px">
    <button
      class="menu-item menu-button logout"
      style="justify-content: space-between"
      (click)="logOut()">
      <mat-icon svgIcon="logout-icon" class="logout-icon"></mat-icon>
      <span class="text-trim">Abmelden</span>
      <div style="width: 15px"></div>
    </button>
  </div>
</div>
